import React from 'react'
import { Input, FormField, Label } from 'pcln-design-system'
import { Search, Warning } from 'pcln-icons'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const BottomDisplay = styled(Label)`
  position: relative;
  top: -36px;
  text-align: center;
`

const noop = () => {}

class TypeAheadInput extends React.Component {
  render () {
    const {
      color,
      hasError,
      id,
      label,
      onChange,
      autoHide,
      icon,
      passedThroughProps,
      hideIcon,
      searchItems,
      isLargeInput, // TODO: HP_LP_FLIGHTS_LARGER_INPUTS, HP_LP_VP_LARGER_INPUTS and HP_RC_LARGER_INPUTS cleanup
      onTypeaheadKeyUp,
      name,
      value,
      ...props
    } = this.props

    const BOTTOM_DISPLAY_DEFAULT = 'City or Airport'
    const parseBottomDisplay = (value, items) => {
      const match = items && items.filter(x => x.id === value)[0]
      if (!match) return BOTTOM_DISPLAY_DEFAULT

      const cityName = match && match.cityName
      const stateCode = match && match.stateCode
      const country = match && match.country
      return `${cityName}, ${stateCode === '--' ? country : stateCode}`
    }
    const bottomText = !value
      ? BOTTOM_DISPLAY_DEFAULT
      : parseBottomDisplay(value, searchItems)

    // TODO: HP_LP_FLIGHTS_LARGER_INPUTS cleanup
    // TODO: HP_LP_VP_LARGER_INPUTS cleanup
    // TODO: HP_RC_LARGER_INPUTS cleanup
    const setDefaultInput = value && label
      ? { height: '46px', paddingTop: '20px', paddingBottom: '8px' }
      : { height: '46px', paddingTop: '8px', paddingBottom: '8px' }
    const checkLabelInput = label
      ? { height: '56px', paddingTop: '18px', paddingBottom: '10px' }
      : { height: '56px' }
    const setLargeInput = value
      ? checkLabelInput
      : { height: '56px', paddingTop: '14px', paddingBottom: '14px' }
    const typeAheadInputStyle = isLargeInput
      ? setLargeInput
      : setDefaultInput

    return (
      <React.Fragment>
        <FormField>
          {label && <Label pb={0} autoHide={autoHide} width='auto'>{label}</Label>}
          {!hideIcon && (icon || <Search color='primary' size={24} />)}
          <Input
            style={typeAheadInputStyle}
            value={value}
            pt={0}
            onChange={onChange}
            {...passedThroughProps}
            id={id}
            autoComplete='off'
            color={color}
            ref={elem => {
              this.inputRef = elem
            }}
            {...props}
            onKeyUp={e => {
              onTypeaheadKeyUp({
                [name]: e.target.value
              })
            }}
          />
          {hasError && <Warning color='red' size={24} />}
        </FormField>
        {hideIcon && <BottomDisplay>{bottomText}</BottomDisplay>}
      </React.Fragment>
    )
  }
}

TypeAheadInput.propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  autoHide: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  passedThroughProps: PropTypes.shape({
    style: PropTypes.object
  }),
  hideIcon: PropTypes.bool,
  icon: PropTypes.node,
  searchItems: PropTypes.array,
  isLargeInput: PropTypes.bool, // TODO: HP_LP_FLIGHTS_LARGER_INPUTS, HP_LP_VP_LARGER_INPUTS and HP_RC_LARGER_INPUTS cleanup
  onTypeaheadKeyUp: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string
}

TypeAheadInput.defaultProps = {
  passedThroughProps: null,
  hideIcon: false,
  onTypeaheadKeyUp: noop
}

export default TypeAheadInput
